import makeRequest from './index'

export default {
  async validateCredentials(user, password) {
    return makeRequest('auth/?select=email,id,name', { user, password })
  },

  getUser(user, password) {
    return makeRequest('pz/user', { user, password })
  }
}
